import React, { useState, useEffect } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, Checkbox } from '@chakra-ui/react';
import { noop } from "../../utils";
export var EditCreditCardModal = function EditCreditCardModal(props) {
  var _a = props.onConfirm,
      onConfirm = _a === void 0 ? noop : _a,
      disclosure = props.disclosure;
  var isOpen = disclosure.isOpen,
      onClose = disclosure.onClose;

  var _b = useState(Boolean(props.isPrimary)),
      isPrimary = _b[0],
      setPrimary = _b[1];

  useEffect(function () {
    if (isOpen) {
      setPrimary(Boolean(props.isPrimary));
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    blockScrollOnMount: false,
    isCentered: true
  }, /*#__PURE__*/React.createElement(ModalOverlay, null), /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement(ModalHeader, null, "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15 / \u0E40\u0E14\u0E1A\u0E34\u0E15"), /*#__PURE__*/React.createElement(ModalCloseButton, null), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Checkbox, {
    isChecked: isPrimary,
    colorScheme: "brand",
    onChange: function onChange(e) {
      setPrimary(e.currentTarget.checked);
    }
  }, "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19")), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    colorScheme: "brand",
    width: "full",
    size: "lg",
    onClick: function onClick() {
      onConfirm({
        isPrimary: isPrimary
      });
      onClose();
    }
  }, "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01"))));
};